import { AdCard, PostModel } from '../../../data-layer/posts/types';
import { toPostUI } from '../../../mappers/posts/toPostUI';
import { AD_COMPACT_FOOTER_HEIGHT } from '../../../ui/posts/PostAdCompactCard';
import { POST_GRID_CARD_FOOTER_HEIGHT } from '../../../ui/posts/PostCardGrid/constants';
import { calculateGridCardHeight } from '../../../ui/posts/PostCardGrid/utils';
import { PRODUCT_PREVIEW_HEIGHT } from '../../../ui/posts/ProductsPreview/constants';
import { hasAvailableProducts } from '../../../utils/hasAvailableProducts';

export const getItemHeight = (
    itemsWithAds: (
        | (PostModel & {
              isAd: false;
          })
        | AdCard
    )[],
    index: number,
    width: number,
) => {
    const postModel = itemsWithAds[index];
    if (!postModel) {
        return 0;
    }

    const baseHeight = postModel.isAd
        ? width + AD_COMPACT_FOOTER_HEIGHT + POST_GRID_CARD_FOOTER_HEIGHT
        : calculateGridCardHeight(width, toPostUI(postModel).content, postModel.postType);

    const extraHeight =
        !postModel.isAd && hasAvailableProducts(postModel) ? PRODUCT_PREVIEW_HEIGHT : 0;

    return baseHeight + extraHeight;
};
